export default {
  blue: 'app-blue',
  green: 'app-green',
  red: 'app-red',
  orange: 'app-orange'
};
